<div class="scaffold-control-component" *ngIf="info">

  <div class="top-row-controls-container" *ngIf="item.paginate_results||item.allow_searching">

  <scaffold-search-bar *ngIf="item.allow_searching" [allowSearch]="item.allow_searching" [hideTermSelect]="item.hide_terms" (search)="search($event)" [searchData]="this.item.columns" [perPageOptions]="this.item.pageCounts" [(perPage)]="perPage" [countLabel]="getCountLabel()"></scaffold-search-bar>


  <scaffold-paginate-page-select
  *ngIf="item.paginate_results"
  [perPageOptions]="item?.pageCounts"
  (perPageChange)="perPageChange($event)"
  [(perPage)]="perPage"
  [countLabel]="getCountLabel()"
></scaffold-paginate-page-select>
</div>


  <div style="text-align:right;" *ngIf="!item.prevent_add">



    <p-button severity="link" variant="text" class="btn btn-default" (click)="openSearch(info,getContext(),true)" [disabled]="checkDisable()">
      <span *ngIf="item.use_icon" class="create-button-icon">
        <i [ngClass]="item.icon"></i>
      </span> {{item.translation_key_button_label||item.label||'search'| translation|translationFromString | transformText :item?.text_transform_button_label}}
    </p-button>
  </div>





  
  
  <div class="loading-table-wrapper">
    <div
      class="loading-table-overlay-spinner-container"
      *ngIf="isProcessing">
      <app-loading-dots size="5px"></app-loading-dots>
    </div>
    <div [ngClass]="{ 'loading-table-overlay': isProcessing }">
      <div class="scaffold-list-holder" [appFlexColumnHeight]="item.fill_height" [ngClass]="{'horizontal-list':item.is_horizontal, 'horizontal-list-1':item.linked && item.linked.length == 1, 'horizontal-list-2':item.linked && item.linked.length == 2, 'no-wrap-list':item.prevent_wrap}">
        
        <ng-container *ngIf="item.use_headers">
          <header style="display: flex; margin: 16px 0px;">
            <label *ngFor="let header of item.headers" [class]="header.header_width||'flex-column-1'">
              {{header.translation_key_header||header?.header_text| translation|translationFromString | transformText :header?.text_transform_header}}
            </label>
          </header>
        </ng-container>

        <div class="align-center fa-2x" *ngIf="loading">
          <scaffold-loading-animation></scaffold-loading-animation>
        </div>



        <div *ngFor="let link of item.linked; let $i = index; last as isLast" class="scaffold-list-item">
          <div [ngClass]="{'inline-block':item.list_seperator}">
            <app-view *ngIf="link && link.data" [items]="link.data.content" [info]="link" [data]="link_data[$i]" [linkList]="item" (deleteDataEvent)="deleteHandler($event)" (moveHandler)="moveItem(link,item.linked,$i, info)" (openViewHandler)="openViewHandler($event, link)" (openLinkHandler)="openLinkHandler($event, link)"></app-view>


          </div>
          <span style="display:inline-block;padding-right: 4px;" *ngIf="!isLast && item.is_horizontal">{{item.list_seperator}}</span>
        </div>
        <scaffold-paginator *ngIf="item.paginate_results && itemCount && itemCount > perPage" [itemCount]="itemCount" [(activePage)]="active" [perPage]="perPage"></scaffold-paginator>

      </div>
    </div>
  </div>
</div>
